class ShadeFinderQuizModelFits extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.setupContinueListeners()
    this.setupBackListeners()

    // Listen for when this step is active
    this._observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isActive = mutation.target.classList.contains('is-active')
          this.carouselManager(isActive)
        }
      }
    })

    this._observer.observe(this, { attributes: true })
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this._observer?.disconnect()
  }

  setupContinueListeners () {
    const continueBtns = document.querySelectorAll('[data-lighter-shade-section-trigger]')

    continueBtns.forEach(continueBtn => {
      this.listeners.add(continueBtn, 'click', () => {
        document.querySelector('shade-finder-quiz-modelfits').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-lighter-shade').classList.add('is-active')
      })
    })
  }

  setupBackListeners () {
    const backBtns = document.querySelectorAll('[data-modelfit-section-back-trigger]')

    backBtns.forEach(backBtn => {
      this.listeners.add(backBtn, 'click', () => {
        document.querySelector('shade-finder-quiz-modelfits').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-skintone').classList.add('is-active')

        const radioInputs = document.querySelectorAll('.sec-QuizContent_SkintoneBlockRadioInput')
        radioInputs.forEach(input => {
          input.checked = false
        })

        const continueBtns = document.querySelectorAll('[data-modelfit-section-trigger]')
        continueBtns.forEach(continueBtn => {
          continueBtn.setAttribute('disabled', '')
        })
      })
    })
  }

  cloneSlides (slides) {
    const slideContainer = document.querySelector('[data-shade-finder-quiz-modelfits-el="slides"]')
    const existingSlides = slideContainer.querySelectorAll('[data-shade-finder-quiz-modelfits-el="slide"]')

    existingSlides.forEach(existingSlide => {
      slideContainer.removeChild(existingSlide)
    })

    slides.reverse().forEach(slide => {
      const clonedSlide = slide.cloneNode(true)
      clonedSlide.removeAttribute('data-shade-finder-quiz-skintone-el')
      clonedSlide.setAttribute('data-shade-finder-quiz-modelfits-el', 'slide')

      const clonedInput = clonedSlide.querySelector('[data-shade-finder-quiz-skintone-el="slide-input"]')
      clonedInput.removeAttribute('data-shade-finder-quiz-skintone-el')

      clonedInput.addEventListener('click', () => {
        const continueBtns = document.querySelectorAll('[data-shade-finder-continue-button]')

        continueBtns.forEach(continueBtn => {
          continueBtn.setAttribute('data-skin-base-variant-id', clonedInput.getAttribute('data-skin-base-variant-id'))
          continueBtn.setAttribute('data-concealer-true-match-variant-id', clonedInput.getAttribute('data-concealer-true-match-variant-id'))
          continueBtn.setAttribute('data-concealer-lighter-shade-variant-id', clonedInput.getAttribute('data-concealer-lighter-shade-variant-id'))
          continueBtn.setAttribute('data-shade-matrix-id', clonedInput.getAttribute('data-shade-matrix-id'))
        })
      })

      slideContainer.prepend(clonedSlide)
    })
  }

  carouselManager (pageActive) {
    if (pageActive === true) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

      // Find selected slide element
      const modelSlides = document.querySelectorAll('[data-shade-finder-quiz-skintone-el="slide"]')
      const trigger = document.querySelector('[data-lighter-shade-section-trigger]')
      if (!trigger) return

      const modelSlideIndex = parseInt(trigger.getAttribute('data-selected-skintone-index'))

      // validate and duplicate one shade lighter/darker from the selected slide element
      const slidesToClone = []
      if (modelSlideIndex != -1) {
        if (modelSlides[modelSlideIndex - 1]) {
          slidesToClone.push(modelSlides[modelSlideIndex - 1])
        }

        slidesToClone.push(modelSlides[modelSlideIndex])

        if (modelSlides[modelSlideIndex + 1]) {
          slidesToClone.push(modelSlides[modelSlideIndex + 1])
        }

        this.cloneSlides(slidesToClone)
      }

      this.carousel = this.setupCarousel()

      if (document.querySelectorAll(`${this.els.slide.selector}:not([aria-hidden='true'])`).length >= 3) {
        this.carousel.moveToIdx(1)
      }
    } else {
      if (this.carousel) {
        this.carousel.destroy()
      }
    }
  }

  setupCarousel () {
    let loop = false

    if (document.querySelectorAll(`${this.els.slide.selector}:not([aria-hidden='true'])`).length >= 3) {
      loop = true
    }

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: `${this.els.slide.selector}:not([aria-hidden='true'])`,
        defaultAnimation: {
          duration: 1500,
        },
        loop,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.5,
          spacing: 2,
          origin: 'center',
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 6.5,
            },
            loop: false,
          },
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('shade-finder-quiz-modelfits')) {
  customElements.define('shade-finder-quiz-modelfits', ShadeFinderQuizModelFits)
}
